import i18n from './i18n.json';

const newi18n = {};
Object.entries(i18n).forEach((element) => {
    newi18n[element[0]] = element[1].fr;
});

export default newi18n;
